import cn from 'classnames';
import printJS from 'print-js';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { addShipmentPostings, changeShipmentPostingMany } from '../../../actions/postings';
import { uiChangeShipmentMode } from '../../../actions/ui';
import PostingsApi from '../../../API/shipment/postings-api';
import PostingsOzonApi from '../../../API/shipment/postingsOzon-api';
import ShipmentsApi from '../../../API/shipment/shipments-api';
import ShipmentWorkApi from '../../../API/shipment/work-api';
import WarehouseCommonApi from '../../../API/warehouse/common-api';
import close from '../../../assets/media/icons/close.svg';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { LinkBlue, Switch } from '../../../components/Basic/Elements';
import { Content, PageTitle } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { H1, Text, TextGrey } from '../../../components/Basic/WrapsStyle';
import AddToCheckupsPopUp from '../../../components/Shipments/AddToCheckupsPopUp';
import {
  MAP_SKLAD,
  MARKETS_ALL,
  TYPE_BUTTONS
} from '../../../constans';
import { getDate, getDateMonth, numberWithSpaces } from '../../../utils';
import AddToRealizationPopUp from './PopUps/AddToRealization';
import MovePostingsToShipmentPopUp from './PopUps/MovePostingsToShipment';
import PostingLine from './PostingLine';
import ChznWindowPopUp from './PostingLine/ChznWindow';
import styles from './styles.module.scss';
import SummaryBlock from './SummaryBlock';

const MARKETS = {
  ozon: ['OZON-1', 'OZON-2', 'OZON-3', 'OZON-4', 'OZON-5', 'OZON-6', 'OZON-7'],
  yandex: ['B-WHITE FBS', 'U-RURU FBS'],
  wb: ['WB-1', 'WB-2', 'WB-3', 'WB-4', 'WB-5', 'WB-6', 'WB-7'],
  megamarket: ['SBER-1', 'SB ER-2'],
};

const SHOPS = {
  ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];


const MODES = ['Режим финансов'];
const MODES_OWNER = ['Режим финансов'];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
  '120px', // 14
];

const STATUSES = ['Не выбран', 'Нет в наличии', 'Резерв', 'Частичный резерв', 'Излишки', 'Не хватает'];

const STATUSES_ALL = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];

const STATUSES_ORDERS_WB = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];
const STATUSES_ORDERS_OZON = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
];

const STATUSES_ORDERS_SBER = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Отменено',
  'Отменено клиентом',
];

const STATUSES_ORDERS_YANDEX = ['Не выбран', 'Ожидает отгрузки', 'Доставляется', 'Продано', 'Отменено'];

const STATUSES_ORDERS = {
  ozon: STATUSES_ORDERS_OZON,
  yandex: STATUSES_ORDERS_YANDEX,
  wb: STATUSES_ORDERS_WB,
  megamarket: STATUSES_ORDERS_SBER,
  ALL: STATUSES_ALL,
};
const STATUSES_SHIPMENT = ['Не выбран', 'Разложен (не упакован)', 'Упакован', 'Не отсортированы', 'Отсортированы'];

const FILTER = {
  0: 'all',
  1: 'awaiting_shipment',
  2: 'printed',
  3: 'not_printed',
  4: 'not_available',
  5: 'variance',
  6: 'dokup',
};

const CHZN = {
  'Не выбран': null,
  Да: true,
  Нет: false,
};

function ShipmentPage({ isExpress = false }) {
  let location = useLocation();
  console.log('location.state' + location.state?.posting_number);
  const { id } = useParams();

  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();
  const [shipment, setShipment] = useState({ market: '', shop: '', time_scheduled: '' });
  const [shipments, setShipments] = useState([]);

  const [load, setLoad] = useState(false);
  const [calc, setCalc] = useState({

    price: 0,
    purchase: 0,

    commission: 0,
    profit: 0,

    penalties: 0,
    common: 0,

    increased_commission_at_hour: 0

    // amount_orders: 0,
    // profit: 0,
    // price: 0,
    // purchase: 0,
    // other: 0,
    // market_payment: 0,
    // penalties: 0,
    // commision: 0,
    // common: 0,
  });

  const [checkAll, setCheckAll] = useState(false);
  const [pdfFilePath, setPdfFilePath] = useState('');

  const [packagingMode, changePackagingMode] = useState(false);
  const [globalSearch, setGlobalSearch] = useState(false);
  const [globalSearchCompleted, setGlobalSearchCompleted] = useState(false);

  const shipmentMode = 'Режим финансов';

  const [cancelOzonOrders, changeCancelOzonOrders] = useState({ state: false, orders: [] });

  const [postingsPrint, setPostingsPrint] = useState({});
  const [openChzn, setOpenChzn] = useState({ product: null, posting: null, open: false });

  const [isMany, setIsMany] = useState(isExpress);
  const [showRealization, setShowRealization] = useState(false);
  const [showReplaceShipment, setShowReplaceShipment] = useState(false);

  const [marketMany, setMarketMany] = useState(MARKETS_LIST[0]);
  const [shopName, setShopName] = useState('Все');
  const [shop, setShop] = useState('');

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.focus();
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const [market, setMarket] = useState(Object.keys(MARKETS)[0]);
  const [dateFinance, setDateFinance] = useState(new Date());
  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState(location.state?.posting_number || '');

  const [rates, setRates] = useState({});
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [providersIdInShipment, setProvidersIdInShipment] = useState([]);
  const [chzn, setChzn] = useState('Не выбран');
  const [isRealization, setIsRealization] = useState('Не выбран');
  const [realizationDate, setRealizationDate] = useState(undefined);
  const [openReviewType, setOpenReviewType] = useState(false);
  const [warehouseProductsMap, setWarehouseProductsMap] = useState({});
  const [status, changeStatus] = useState(STATUSES[0]);
  const [statusShipment, changeStatusShipment] = useState(STATUSES_SHIPMENT[0]);

  const [orderStatus, changeOrderStatus] = useState('Не выбран');

  const { ids = [], byIds = {}, map = {} } = useSelector((store) => store.postings);

  const updateProviderData = () => {
    PostingsApi.syncProviderData({ data: { shipmentId: shipment.id } }).then((r) => console.log(r));
  };

  const onChangeShipment = (key, value) => {
    ShipmentsApi.changeShipment({ data: { shipmentId: shipment.id, field: key, value } }).then((r) =>
      setShipment(r.shipment),
    );
  };

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  useEffect(() => {
    setMarket(Object.keys(MARKETS)[0]);
  }, []);

  let checkIsPenaltyWbCandidate = (order) => {
    return (
      (order.market === 'wb' &&
        !order.is_printed &&
        order.status === 'Ожидает отгрузки' &&
        ['Нет в наличии', 'Не хватает'].includes(order.products[0].diff.status) && order.products[0].dokup.status !== 'Заказан')
      ||
      order.status === 'Отменено' || (order.status === 'Отменено клиентом' && !order.delivering_status_update_date)
    );
  };

  const params = useMemo(() => {
    const s = status === STATUSES[0] ? '' : status;
    const shop_name = shopName === 'Все' ? '' : shopName;
    const order_status = orderStatus === 'Не выбран' ? '' : orderStatus;
    const shipment_status = statusShipment === 'Не выбран' ? '' : statusShipment; //статус отгрузки заказа

    let shipment_ids = undefined;
    if (!isExpress) {
      // не экспрессы
      shipment_ids = id.split('&');
      shipment_ids = shipment_ids.map((item) => parseInt(item));
    }

    return {
      shipmentIds: shipment_ids,
      shipmentFilter: isExpress
        ? {
          isExpress,
          shipmentState: 'started',
        }
        : undefined,
      limit: parseInt(show),
      page,
      search: search.trim(),
      providerId: provider.id,
      tab: FILTER[tab],
      market: shipment_ids?.length === 1 || marketMany === 'Не выбрана' ? undefined : marketMany.toLowerCase(),
      shop: shop_name,
      sortType: 'shipments',
      globalSearch,
      filters: {
        orderStatus: order_status,
        stateStatus: shipment_status,
        productsStatus: s,
        chzn: CHZN[chzn],
        isRealizated: isRealization === 'Не выбран' ? undefined : isRealization === 'Да',
        realizationDate,
        isPackageMethodEmpty: packagingMode,
      },
    };
  }, [
    id,
    show,
    page,
    search,
    tab,
    provider.id,
    status,
    shopName,
    orderStatus,
    statusShipment,
    marketMany,
    chzn,
    isRealization,
    realizationDate,
    packagingMode,
    globalSearch
  ]);

  const loadData = () => {
    PostingsApi.getPostingsByShipmentIds({ data: params })
      .then((res) => {
        const { data, postings, cardsMap, count, all_count, financesGrouped } = res;
        const byIds = {};
        setCountStock([
          all_count.all,
          all_count.awaiting_shipment,
          all_count.printed,
          all_count.not_printed,
          all_count.not_available,
          all_count.variance,
          all_count.dokup,
        ]);

        const ids = postings.map((item) => item.posting_number);
        postings.forEach((item) => (byIds[item.posting_number] = item));

        dispatch(addShipmentPostings({ byIds, ids, map: cardsMap }));

        setPostingsPrint({});

        if (res.shipments.length === 1 && !isExpress) {
          setShipment(res.shipments[0]);
        } else {
          setShipments(res.shipments);
        }
        setGlobalSearchCompleted(res.globalSearchCompleted)
        setWarehouseProductsMap(res.warehouseProductsMap);
        setProvidersIdInShipment(res.providersIdsInShipments);
        setCount(count);
        setCalc({ ...financesGrouped })
        setLoad(true);
        setShop(MARKETS_ALL[res.shipments[0].market][0]);
      })
      .catch((err) => {
        console.log(err);
        if (err.code === 140) {
          setError('Не удалось отгрузку');
        }
      });
  };

  const loadPackagingStatistic = () => {
    ShipmentsApi.getPackageStatistic({ data: { shipmentId: id } }).then((r) => setRates(r.map));
  };

  useEffect(() => {
    console.log(id);
    if (id) {
      const shipment_ids = id.split('&');
      if (isOwner && shipment_ids?.length === 1) {
        loadPackagingStatistic();
      }

      setIsMany(shipment_ids.length > 1);
    }
  }, [id]);

  useEffect(() => {
    loadData();
  }, [params]);

  const onClickLoadStatus = async () => {
    await PostingsApi.updatePostingsStatus({ data: { shipmentId: shipment.id } });
    await loadData(id);
  };

  useEffect(() => {
    const p = allProviders.filter((item) => providersIdInShipment.map(r => r._id)?.includes(item.id));
    setProviders([{ name: 'Не выбран', id: null }, ...p]);
  }, [allProviders, providersIdInShipment]);

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  const isDisabledPrint = (order) => {
    if (user.role === 'owner') {
      return false;
    }
    return (
      (!order.is_sticker_load && !order.is_printed) ||
      !(
        order.status === 'Ожидает отгрузки' ||
        order.status === 'Ожидает упаковки' ||
        order.status === 'Ожидает регистрации' ||
        order.status === 'Не принят на CЦ' ||
        order.status === 'Арбитраж' ||
        (order.status === 'Доставляется' && !order.is_printed)
      ) ||
      order.products.reduce((state, product) => {
        return state || (product.chzn.is_has && !product.chzn.is_missing && product.chzn.value.length < 10);
      }, false)
    );
  };

  const changePostingPrint = (order_number) => {
    if (postingsPrint[order_number]) {
      const s = postingsPrint;
      delete s[order_number];
      setPostingsPrint({ ...s });
    } else {
      setPostingsPrint({ ...postingsPrint, [order_number]: true });
    }
  };

  const changePrintStatus = async (numbers = [], s) => {
    await ShipmentWorkApi.changePrint({ data: { postingNumbers: numbers, isPrint: s } }).then((r) => {
      const p = r.postings;
      const changeByIds = {};
      p.forEach((item) => {
        changeByIds[item.posting_number] = item;
      });
      dispatch(changeShipmentPostingMany(changeByIds));
    });
  };

  const printSticker = useCallback(
    async (order) => {
      const r = { postingNumbers: [order.posting_number] };

      let file = await ShipmentWorkApi.pickerScan({ data: { postingNumbers: [order.posting_number] } });

      printJS({
        printable: file,
        type: 'pdf',
        base64: true,
        showModal: false,
        onPrintDialogClose: () => {
          window.focus();
          setInputFocus();
        },
      });
      await changePrintStatus([order.posting_number], true);
      setInputFocus();
    },
    [pdfFilePath],
  );

  const printAll = async () => {
    let postingNumbers = Object.keys(postingsPrint);
    const r = { postingNumbers };

    let file = await ShipmentWorkApi.pickerScan({ data: { postingNumbers } });

    printJS({
      printable: file,
      base64: true,
      type: 'pdf',
      onPrintDialogClose: () => setInputFocus(),
    });
    await changePrintStatus(postingNumbers, true);

    setCheckAll(false);
    setPostingsPrint({});

    setTimeout(setInputFocus, 1000);
  };

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_print = {};
      ids.forEach((item) => {
        const order = byIds[item];
        const is_disabled_print = isDisabledPrint(order);

        if (!is_disabled_print) {
          map_print[order.posting_number] = true;
        }
      });
      setPostingsPrint(map_print);
      setCheckAll(true);
    } else {
      setCheckAll(false);

      setPostingsPrint({});
    }
  };
  const tab_name =
    isMany || isExpress
      ? isExpress
        ? 'Экспрессы'
        : 'Cовместная отгрузка'
      : `Отгрузка: ${shipment.market || ''} ${shipment.time_scheduled ? getDate(shipment.time_scheduled) : ''}`;

  const cancelOrders = async (orders) => {
    await PostingsOzonApi.cancelPostings({ data: { postingsNumbers: orders } }).then((r) => {
      changeCancelOzonOrders({ state: false, orders: [] });

      const p = r.postings;
      const changeByIds = {};
      p.forEach((item) => {
        changeByIds[item.posting_number] = item;
      });
      dispatch(changeShipmentPostingMany(changeByIds));
      setPostingsPrint({});
    });
  };

  const onChangeWarehouseReserve = async (id, field, value, postingNumber, skladName, reason) => {
    await WarehouseCommonApi.changeProduct({
      data: { warehouseId: id, field, value, postingNumber, skladName, reason },
    })
      .then((r) => {
        setWarehouseProductsMap({ ...warehouseProductsMap, [r.warehouseProduct.id]: r.warehouseProduct });
      })
      .catch();
  };

  useEffect(() => {
    changePackagingMode(false);
  }, [shipmentMode]);

  const modes = isOwner ? MODES_OWNER : MODES;

  const sum = (Object.keys(rates) || [])
    .map((key) => rates[key])
    .reduce(
      (prev, item, index) => {
        return { count: prev.count + item.count, payment: prev.payment + item.payment };
      },
      { payment: 0, count: 0 },
    );

  useEffect(() => {
    setShopName('Все');
  }, [marketMany]);

  const shipments_text = shipments.map(
    (item) =>
      `${item.market || ''} ${item.is_express ? ' Express ' : ''} ${item.time_scheduled ? getDateMonth(item.time_scheduled) : ''
      }`,
  );

  return (
    <>
      <PageTitle title={tab_name || ''} />
      <Content>
        <H1 style={{ marginBottom: '-3px' }}>
          {isMany || isExpress
            ? `Совместная отгрузка: ${shipments_text.join(' + ')} ${MAP_SKLAD[shipments[0]?.sklad]}`
            : `Отгрузка: ${shipment.market || ''}  ${shipment.is_express ? ' Express ' : ''} ${shipment.time_scheduled ? getDate(shipment.time_scheduled) : ''
            } ${MAP_SKLAD[shipment.sklad]}`}
        </H1>
        <LinkBlue to={'/shipment/shipments'} style={{ marginBottom: '10px' }}>
          Вернуться к отгрузкам
        </LinkBlue>

        <SummaryBlock providersIdInShipment={providersIdInShipment} provider={provider} allProviders={allProviders} />

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={[
                'Все заказы',
                'Ожидают отгрузки',
                'Обработаны',
                'Не обработаны',
                'Нет в наличии',
                'Расхождения',
                'Докупы',
              ]}
              isNum={true}
              num={countStock}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
            <Row>
              {isOwner && (
                <Row style={{ width: '200px' }}>
                  <TextGrey style={{ marginRight: '10px' }}>Глобальный поиск</TextGrey>
                  <Switch switched={globalSearch} onClick={(v) => setGlobalSearch(v)} />
                </Row>
              )}
              {isOwner && shipmentMode === modes[4] && (
                <Row style={{ width: '270px', marginRight: '10px' }}>
                  <TextGrey style={{ marginRight: '10px' }}>Показать заказы без упаковки</TextGrey>
                  <Switch switched={packagingMode} onClick={(v) => changePackagingMode(v)} />
                </Row>
              )}
              <Select
                style={{ width: 'auto' }}
                select={shipmentMode}
                list={modes}
                onSelect={(v) => dispatch(uiChangeShipmentMode(v))}
                width="150px"
              />
            </Row>
          </Row>

          <Row className={styles.row_input}>
            {Object.keys(postingsPrint).length > 0 ? (
              <Row className={styles.row_select}>
                <Row>
                  <Button type={TYPE_BUTTONS.WHITE} style={{ marginRight: '15px' }} onClick={() => printAll()}>
                    Распечатать этикетки
                  </Button>

                  <Button
                    type={TYPE_BUTTONS.RED}
                    style={{ marginRight: '15px' }}
                    onClick={() => {
                      setCheckAll(false);
                      setPostingsPrint({});
                      setTimeout(setInputFocus, 1000);
                    }}
                  >
                    Очистить выбор
                  </Button>
                  {isOwner && (
                    <Button
                      type={TYPE_BUTTONS.GREEN}
                      style={{ marginRight: '15px' }}
                      onClick={() => setShowRealization(true)}
                    >
                      Перенести в реализацию
                    </Button>
                  )}

                  {isOwner && (
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      style={{ marginRight: '15px' }}
                      onClick={() => setShowReplaceShipment(true)}
                    >
                      Перенести в другую отгрузку
                    </Button>
                  )}

                  {isOwner && (
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      style={{ marginRight: '15px' }}
                      onClick={() => setOpenReviewType(true)}
                    >
                      Перенести в проверку
                    </Button>
                  )}
                </Row>
              </Row>
            ) : (
              <Input
                value={search}
                ref={inputRef}
                onBlur={(v) => setSearch(v)}
                onClickEnter={(v) => setSearch(v)}
                label="Поиск"
              />
            )}
          </Row>

          <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

          <Row spaceBetween={true}>
            <Row style={{ height: '40px' }}>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />

              {isMany ? (
                <>
                  <Select
                    list={MARKETS_LIST}
                    select={marketMany}
                    label="Площадка"
                    onSelect={(v) => setMarketMany(v)}
                    width={'150px'}
                    style={{ marginRight: '15px' }}
                  />
                  <Select
                    list={SHOPS[marketMany.toLowerCase()] || []}
                    select={shopName}
                    disabled={marketMany === MARKETS_LIST[0]}
                    label="Магазин"
                    onSelect={(v) => setShopName(v)}
                    width={'150px'}
                    style={{ marginRight: '15px' }}
                  />
                </>
              ) : (
                <Select
                  label="Магазин"
                  select={shopName}
                  list={SHOPS[shipment.market]}
                  width="130px"
                  onSelect={(v) => setShopName(v)}
                  style={{ marginRight: '15px' }}
                />
              )}

              <Select
                label="Поставщик"
                select={provider}
                valueFn={(p) => p.name}
                list={providers}
                width="200px"
                onSelect={(v) => changeProvider(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Статус отгрузки"
                select={statusShipment}
                list={STATUSES_SHIPMENT}
                width="200px"
                style={{ marginRight: '15px' }}
                onSelect={(v) => changeStatusShipment(v)}
              />
              <Select
                label="Статус товара"
                select={status}
                list={STATUSES}
                width="200px"
                onSelect={(v) => changeStatus(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Статус заказа"
                select={orderStatus}
                list={isMany ? STATUSES_ALL : STATUSES_ORDERS[shipment.market]}
                width="200px"
                style={{ marginRight: '15px' }}
                onSelect={(v) => changeOrderStatus(v)}
              />
              <Select
                label="Честный знак"
                select={chzn}
                list={['Не выбран', 'Да', 'Нет']}
                width="140px"
                style={{ marginRight: '15px' }}
                onSelect={(v) => setChzn(v)}
              />

              {(isOwner || user.role === 'user') && (
                <>
                  <Select
                    label="Реализовано"
                    select={isRealization}
                    list={['Не выбран', 'Да', 'Нет']}
                    width="140px"
                    style={{ marginRight: '15px' }}
                    onSelect={(v) => setIsRealization(v)}
                  />
                  <Column style={{ marginRight: '10px' }}>
                    <InputLabel>Дата реализации</InputLabel>
                    <Row style={{ position: 'relative', width: '150px' }}>
                      <DateInput
                        value={realizationDate}
                        className={styles.calendar}
                        onChange={(v) => setRealizationDate(v)}
                      />
                      <Button className={styles.close_button} onClick={() => setRealizationDate(undefined)}>
                        <img src={close} style={{ width: '15px' }} />
                      </Button>
                    </Row>
                  </Column>
                </>
              )}
            </Row>
          </Row>
        </WhiteBlock>

        <Table styles={styles.table}>
          {user.role === 'owner' && shipmentMode === MODES[0] && (
            <TableHeader whiteHeader>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Всего заказов на сумму: </TextGrey>
                <Text className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(calc.price))}</Text>
              </Row>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Комиссии: </TextGrey>
                <Text className={cn(styles.profit, styles.red)}>- {numberWithSpaces(Math.ceil(calc.commission))}</Text>
              </Row>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Пов.ком % / руб. / в час: </TextGrey>
                {/* <Tooltip */}
                {/* text={`${calc.increased_commission_average} % / ${+calc.increased_commission_at_hour.toFixed(2)} в час `} */}
                {/* > */}
                {/* <Text className={cn(styles.profit, styles.red)}>- {numberWithSpaces(Math.ceil(calc.increased_commission_rub))}</Text> */}
                <Text className={cn(styles.profit, styles.red)}>{numberWithSpaces(calc.increased_commission_average)}% / - {numberWithSpaces(Math.ceil(calc.increased_commission_rub))} / - {numberWithSpaces(Math.ceil(calc.increased_commission_at_hour))}</Text>
                {/* </Tooltip> */}
              </Row>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Закупка: </TextGrey>
                <Text className={cn(styles.profit, styles.blue)}>
                  {'- '}
                  {numberWithSpaces(Math.ceil(calc.purchase))}
                </Text>
              </Row>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Прибыль: </TextGrey>
                <Text className={cn(styles.profit, calc.profit > 0 ? styles.green : styles.red)}>
                  {`${calc.profit > 0 ? '+ ' : ''}${numberWithSpaces(Math.ceil(calc.profit))}`}
                </Text>
              </Row>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Штрафы: </TextGrey>
                <Text className={cn(styles.profit, styles.red)}>
                  {'- '}
                  {numberWithSpaces(Math.ceil(calc.penalties))}
                </Text>
              </Row>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Операционные ошибки: </TextGrey>
                <Text className={cn(styles.profit, styles.red)}>
                  {'- '}
                  {numberWithSpaces(Math.ceil(calc.operation_mistakes))}
                </Text>
              </Row>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Обработка возвратов: </TextGrey>
                <Text className={cn(styles.profit, styles.red)}>
                  {'- '}
                  {numberWithSpaces(Math.ceil(calc.returns))}
                </Text>
              </Row>
              <Row className={styles.block_calc}>
                <TextGrey className={styles.text_grey}>Итого: </TextGrey>
                <Text className={cn(styles.profit, calc.common > 0 ? styles.green : styles.red)}>
                  {`${calc.common > 0 ? '+ ' : ''}${numberWithSpaces(Math.ceil(calc.common))}`}
                </Text>
              </Row>
              <Row className={styles.block_calc} style={{ marginLeft: '40px' }}></Row>
              <Row className={styles.block_calc}></Row>
              <Row className={styles.block_calc}></Row>
              <Row className={styles.block_calc}></Row>
            </TableHeader>
          )}
          <TableHeader style={globalSearchCompleted ? { backgroundColor: '#ffd66dff' } : {}} whiteHeader>
            <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
            {/* {globalSearchCompleted && <HeaderTitle width={WIDTH_POSTING[0]} centerText>Дата отгрузки</HeaderTitle>} */}
            <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
              Количество
            </HeaderTitle>
            {shipmentMode === modes[4] && (
              <>
                <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
                  Способ упаковки
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                  Цена продажи
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                  Цена закупки
                </HeaderTitle>
              </>
            )}
            <HeaderTitle width={WIDTH_POSTING[5]} centerText={true}>
              Статус товара
            </HeaderTitle>
            {shipmentMode === MODES[0] && (
              <>
                <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                  Цена продажи
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                  Цена закупки
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                  Комиссия мп
                </HeaderTitle>

                <HeaderTitle width={WIDTH_POSTING[14]} centerText={true}>
                  Прибыль
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                  Штраф
                </HeaderTitle>
              </>
            )}

            <HeaderTitle width={WIDTH_POSTING[3]} centerText={true}>
              Статус заказа
            </HeaderTitle>

            {shipmentMode === MODES[0] && (
              <>
                <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                  Дата прихода заказа
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                  Дата сортировки на СЦ
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[10]} centerText={true}>
                  Время отгрузки, часов
                </HeaderTitle>
              </>
            )}

            {(shipmentMode === modes[1] || tab === 6) && (
              <>
                <HeaderTitle width={WIDTH_POSTING[9]} centerText={true} />

                <HeaderTitle width={WIDTH_POSTING[13]} centerText={true}>
                  Артикул поставщика
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[12]} centerText={true}>
                  Статус повторного заказа
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[12]} centerText={true}>
                  Поставщик
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>
                  Дата прихода на склад
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
                  Расхождениe при отгрузке
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
                  Статус оформления расхождения
                </HeaderTitle>
              </>
            )}

          </TableHeader>
          {ids.map((order) => {
            return (
              <PostingLine
                isAdmin={isAdmin}
                shipmentMode={shipmentMode}
                globalSearchCompleted={globalSearchCompleted}
                packagingMode={packagingMode}
                MODES={modes}
                FILTER={FILTER}
                tab={tab}
                order={byIds[order]}
                shipment={shipment}
                map={map}
                key={byIds[order].posting_number}
                printSticker={printSticker}
                changePrintStatus={changePrintStatus}
                postingsPrint={postingsPrint}
                changePostingPrint={changePostingPrint}
                onChangeWarehouseReserve={onChangeWarehouseReserve}
                setOpenChzn={setOpenChzn}
                isMany={isMany}
                isExpress={isExpress}
                isDisabledPrint={isDisabledPrint}
                warehouseProductsMap={warehouseProductsMap}
                isPenaltyCandidate={checkIsPenaltyWbCandidate(byIds[order])}
              />
            );
          })}
        </Table>
        {cancelOzonOrders.state && (
          <CancelOrders
            onClickOk={(orders) => cancelOrders(orders)}
            orders={cancelOzonOrders.orders}
            close={() => changeCancelOzonOrders({ state: false, orders: [] })}
          />
        )}

        <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
        {openChzn.open && (
          <ChznWindowPopUp
            product={openChzn.product}
            posting={openChzn.posting}
            close={() => setOpenChzn({ open: false, posting: null, product: null })}
          />
        )}
        {showRealization && (
          <AddToRealizationPopUp
            postings={Object.keys(postingsPrint)}
            market={shipment.market}
            num={Object.keys(postingsPrint).length}
            shop={shop}
            close={() => {
              setShowRealization(false);
              loadData();
            }}
          />
        )}
        {showReplaceShipment && (
          <MovePostingsToShipmentPopUp
            postings={Object.keys(postingsPrint)}
            market={shipment.market}
            num={Object.keys(postingsPrint).length}
            shop={shop}
            close={() => {
              setShowReplaceShipment(false);
              loadData();
            }}
          />
        )}
        {openReviewType && (
          <AddToCheckupsPopUp
            clickOk={() => { }}
            reason_type="Отгрузка"
            close={() => setOpenReviewType(false)}
            postings={Object.keys(postingsPrint)}
          />
        )}
      </Content>
    </>
  );
}

export default ShipmentPage;
